import { render, staticRenderFns } from "./OrderShipmentList.vue?vue&type=template&id=112bd594&scoped=true&"
import script from "./OrderShipmentList.vue?vue&type=script&lang=js&"
export * from "./OrderShipmentList.vue?vue&type=script&lang=js&"
import style0 from "./OrderShipmentList.vue?vue&type=style&index=0&id=112bd594&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112bd594",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('112bd594')) {
      api.createRecord('112bd594', component.options)
    } else {
      api.reload('112bd594', component.options)
    }
    module.hot.accept("./OrderShipmentList.vue?vue&type=template&id=112bd594&scoped=true&", function () {
      api.rerender('112bd594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VPL/MyOrder/OrderDetail/OrderShipmentList.vue"
export default component.exports